import { SubmitUserSettingsRequest, UserSettingsRequest, Timezone } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useClientData } from '@/providers/ClientData.provider';
import vopayApi from '@/services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostSubmitUserSettings() {
    const [, setDataFetchingInfo] = useDataFetchIndicator();
    const { response } = useClientData();
    const source = axios.CancelToken.source();

    const [userSettings, setUserSettings] = useState<{ timezone: Timezone }>({ timezone: 'UTC' });

    const getUserSettings = async (requestParams: UserSettingsRequest) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen');
        const res = await api.fetchUserSettings(requestParams, source);
        setUserSettings({ timezone: res.Settings?.timezone ?? 'UTC' });
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      if (response.Success && response.JWT && response.LoginUserName) {
        getUserSettings({
          EmailAddress: response.LoginUserName,
        });
      }
    }, [response]);

    const submitUserSettings = async (requestParams: SubmitUserSettingsRequest) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen');
        const res = await api.postSubmitUserSettings(requestParams, source);
        // res.Settings = null;
        setUserSettings({ timezone: res.Settings.timezone });
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      userSettings,
      getUserSettings,
      submitUserSettings,
    };
  };
});
export default hook({});
